const contributionModal = () => {
  const contributorBtns = document.querySelectorAll(
    'button.js-open-contributors',
  )
  const contributorModals = document.querySelectorAll(
    'aside.contributors-modal',
  )
  const html = document.querySelectorAll('html')[0]

  if (contributorBtns && contributorModals) {
    contributorBtns.forEach((elm) => {
      elm.addEventListener('click', (e) => {
        const modal = Array.from(contributorModals).find(
          (element) =>
            element.dataset.contributors === elm.dataset.contributors,
        )

        if (!modal) return

        modal.classList.remove('hidden')

        html.classList.add('js-scroll-hidden')
      })
    })

    contributorModals.forEach((elm) => {
      elm.addEventListener('click', (e) => {
        if (
          e.target.classList.contains('contributors-modal') ||
          e.target.classList.contains('close-menu-btn')
        ) {
          elm.classList.add('hidden')
          html.classList.remove('js-scroll-hidden')
        }
      })
    })
  }
}

export default contributionModal
